// In production, leave REACT_APP_API_BASE_URL empty so the frontend
// calls the same origin (vacrm.impactprotech.host). Locally it falls
// back to http://localhost:5000.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

// For migrated PHP actions (uses action= query param).
// Hostinger's Apache hijacks any URL ending in .php and tries to run it
// through PHP-FPM, so we route through /api/action instead. The Node
// server still also accepts /index.php for backwards compatibility.
export const API_URL = `${API_BASE_URL}/api/action`;

// For existing Node.js api routes
export const NODE_API_URL = `${API_BASE_URL}/api`;

export default API_URL;
